/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { Sqlite } from "./Sqlite";
import { SqliteFromJSON, SqliteFromJSONTyped, SqliteToJSON, SqliteToJSONTyped } from "./Sqlite";
import type { RevisionRaster } from "./RevisionRaster";
import {
  RevisionRasterFromJSON,
  RevisionRasterFromJSONTyped,
  RevisionRasterToJSON,
  RevisionRasterToJSONTyped,
} from "./RevisionRaster";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface SchematisationRevision
 */
export interface SchematisationRevision {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly created?: Date | null;
  /**
   *
   */
  readonly schematisation?: string;
  /**
   *
   */
  readonly schematisationId?: number;
  /**
   *
   */
  readonly number?: number;
  /**
   *
   */
  readonly sqlite?: Sqlite;
  /**
   *
   */
  readonly rasters?: Array<RevisionRaster>;
  /**
   *
   */
  readonly archived?: Date | null;
  /**
   *
   */
  readonly commitDate?: Date | null;
  /**
   * The user that committed the revision
   */
  readonly commitUser?: string;
  /**
   *
   */
  readonly commitFirstName?: string | null;
  /**
   *
   */
  readonly commitLastName?: string | null;
  /**
   *
   */
  readonly commitMessage?: string | null;
  /**
   *
   */
  readonly isValid?: boolean | null;
  /**
   *
   */
  readonly hasThreedimodel?: boolean;
  /**
   * tags provided as a list of strings
   */
  tags?: Array<string>;
  /**
   * The revision that this revision was cloned from
   */
  readonly clonedFrom?: string | null;
  /**
   * The id of the revision that this revision was cloned from
   */
  readonly clonedFromRevisionId?: number | null;
  /**
   * The id of the schematisation that this revision was cloned from
   */
  readonly clonedFromSchematisationId?: number | null;
}

/**
 * Check if a given object implements the SchematisationRevision interface.
 */
export function instanceOfSchematisationRevision(value: object): value is SchematisationRevision {
  return true;
}

export function SchematisationRevisionFromJSON(json: any): SchematisationRevision {
  return SchematisationRevisionFromJSONTyped(json, false);
}

export function SchematisationRevisionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SchematisationRevision {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    id: json["id"] == null ? undefined : json["id"],
    created:
      json["created"] === undefined
        ? undefined
        : json["created"] === null
        ? null
        : parseDateTime(json["created"]),
    schematisation: json["schematisation"] == null ? undefined : json["schematisation"],
    schematisationId: json["schematisation_id"] == null ? undefined : json["schematisation_id"],
    number: json["number"] == null ? undefined : json["number"],
    sqlite: json["sqlite"] == null ? undefined : SqliteFromJSON(json["sqlite"]),
    rasters:
      json["rasters"] == null
        ? undefined
        : (json["rasters"] as Array<any>).map(RevisionRasterFromJSON),
    archived:
      json["archived"] === undefined
        ? undefined
        : json["archived"] === null
        ? null
        : parseDateTime(json["archived"]),
    commitDate:
      json["commit_date"] === undefined
        ? undefined
        : json["commit_date"] === null
        ? null
        : parseDateTime(json["commit_date"]),
    commitUser: json["commit_user"] == null ? undefined : json["commit_user"],
    commitFirstName:
      json["commit_first_name"] === undefined
        ? undefined
        : json["commit_first_name"] === null
        ? null
        : json["commit_first_name"],
    commitLastName:
      json["commit_last_name"] === undefined
        ? undefined
        : json["commit_last_name"] === null
        ? null
        : json["commit_last_name"],
    commitMessage:
      json["commit_message"] === undefined
        ? undefined
        : json["commit_message"] === null
        ? null
        : json["commit_message"],
    isValid:
      json["is_valid"] === undefined
        ? undefined
        : json["is_valid"] === null
        ? null
        : json["is_valid"],
    hasThreedimodel: json["has_threedimodel"] == null ? undefined : json["has_threedimodel"],
    tags: json["tags"] == null ? undefined : json["tags"],
    clonedFrom:
      json["cloned_from"] === undefined
        ? undefined
        : json["cloned_from"] === null
        ? null
        : json["cloned_from"],
    clonedFromRevisionId:
      json["cloned_from_revision_id"] === undefined
        ? undefined
        : json["cloned_from_revision_id"] === null
        ? null
        : json["cloned_from_revision_id"],
    clonedFromSchematisationId:
      json["cloned_from_schematisation_id"] === undefined
        ? undefined
        : json["cloned_from_schematisation_id"] === null
        ? null
        : json["cloned_from_schematisation_id"],
  };
}

export function SchematisationRevisionToJSON(json: any): SchematisationRevision {
  return SchematisationRevisionToJSONTyped(json, false);
}

export function SchematisationRevisionToJSONTyped(
  value?: Omit<
    SchematisationRevision,
    | "url"
    | "id"
    | "created"
    | "schematisation"
    | "schematisationId"
    | "number"
    | "sqlite"
    | "rasters"
    | "archived"
    | "commitDate"
    | "commitUser"
    | "commitFirstName"
    | "commitLastName"
    | "commitMessage"
    | "isValid"
    | "hasThreedimodel"
    | "clonedFrom"
    | "clonedFromRevisionId"
    | "clonedFromSchematisationId"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tags: value["tags"],
  };
}
